import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type GetThreadsForUserQueryVariables = Types.Exact<{
   params: Types.GetThreadsForUserParams
}>

export type GetThreadsForUserQuery = {
   __typename?: 'Query'
   getThreadsForUser:
      | {
           __typename?: 'GetThreadsForUserResponseResult'
           totalCount: number
           threads: Array<{
              __typename?: 'Thread'
              threadId: number
              name: string
           }>
        }
      | { __typename?: 'InvalidLimit'; message?: string | null }
      | { __typename?: 'InvalidOffset'; message?: string | null }
      | { __typename?: 'ThreadEntityNotFound' }
}

export const GetThreadsForUserDocument = gql`
   query GetThreadsForUser($params: GetThreadsForUserParams!) {
      getThreadsForUser(params: $params) {
         ... on GetThreadsForUserResponseResult {
            threads {
               threadId
               name
            }
            totalCount
         }
         ... on InvalidOffset {
            message
         }
         ... on InvalidLimit {
            message
         }
      }
   }
`
export type GetThreadsForUserQueryResult = Apollo.QueryResult<
   GetThreadsForUserQuery,
   GetThreadsForUserQueryVariables
>
